import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/Dashboard.css";
import { FaChartLine } from "react-icons/fa6";
import { HiUserGroup } from "react-icons/hi2";
import { BiTimer } from "react-icons/bi";
import { FaRegCalendarCheck } from "react-icons/fa";
import { RiUserAddLine } from "react-icons/ri";
import { TbTreadmill } from "react-icons/tb";
import { BiPieChartAlt2 } from "react-icons/bi";
import { TbFileInvoice } from "react-icons/tb";
import { FaUserNinja } from "react-icons/fa";
import API_URL from "../config";
import { useAdmin } from "../contexts/AdminContext";

const Dashboard = () => {
  const { admin } = useAdmin();
  const navigate = useNavigate();

  const [totalMembersCount, setTotalMembersCount] = useState(0);
  const [renewalMembersCount, setRenewalMembersCount] = useState(0);
  const [membersWithPlanCount, setMembersWithPlanCount] = useState(0);
  const [trainers, setTrainer] = useState(0);

  useEffect(() => {
    if (admin?.branch) {
      const fetchData = async () => {
        try {
          const response = await fetch(
            `${API_URL}/auth/count/members/${admin.branch}`
          );
          const data = await response.json();

          if (data.success) {
            setTotalMembersCount(data.data.totalMembersCount);
            setRenewalMembersCount(data.data.renewalMembersCount);
            setMembersWithPlanCount(data.data.membersWithPlanCount);
          } else {
            console.error("Failed to fetch data:", data);
          }
        } catch (error) {
          console.error("Error fetching data:", error);
        }
      };

      const fetchTrainers = async () => {
        try {
          const response = await fetch(
            `${API_URL}/trainer/branch/${admin?.branch}`
          );
          if (!response.ok) {
            throw new Error("Failed to fetch trainers");
          }
          const data = await response.json();
          setTrainer(data.length);
        } catch (error) {
          console.error("Error fetching trainers:", error);
        }
      };
      fetchTrainers();
      fetchData();
    }
  }, [admin?.branch]);

  return (
    <div className="dashboardContainer">
      <div className="dashboardHeader">
        <FaChartLine size={30} color="#ff0000" style={{ marginRight: 10 }} />
        <h2>Over View</h2>
      </div>
      <h2>Quick Stats</h2>
      <div className="quickStatsContainer">
        <div className="quickStatsDiv">
          <h4>Active Members</h4>
          <div className="blueDiv quickSt">
            <h2>{totalMembersCount}</h2>
            <HiUserGroup size={40} color="white" />
          </div>
        </div>
        <div className="quickStatsDiv">
          <h4>Renewal Members</h4>
          <div className="redDiv quickSt">
            <h2>{renewalMembersCount}</h2>
            <BiTimer size={40} color="white" />
          </div>
        </div>
        <div className="quickStatsDiv">
          <h4>Diet Plans & Exercise Charts</h4>
          <div className="yellowDiv quickSt">
            <div>
              <h2 style={{ color: "white" }}>{membersWithPlanCount}</h2>
              <p style={{ color: "white" }}>Charts Assigned</p>
            </div>
            <FaRegCalendarCheck size={40} color="white" />
          </div>
        </div>
        <div className="quickStatsDiv">
          <h4>Total Trainers</h4>
          <div className="greenDiv quickSt">
            <h2>{trainers}</h2>
            <FaUserNinja size={40} color="white" />
          </div>
        </div>
      </div>

      <h2>Quick Action</h2>
      <div className="quickActionContainer">
        <div
          className="quickAct"
          onClick={() => navigate("/admin/usermanagement/adduser")}
        >
          <h2>Add User</h2>
          <RiUserAddLine size={40} />
        </div>
        <div
          className=" quickAct"
          onClick={() => navigate("/admin/dietplanmanagement")}
        >
          <h3>Add Create/Assign Diet Plan</h3>
          <TbTreadmill size={40} />
        </div>
        <div
          className="quickAct"
          onClick={() => navigate("/admin/exercisemanagement")}
        >
          <h3>Create/Assign Exercise Chart</h3>
          <BiPieChartAlt2 size={40} />
        </div>
        <div
          className="quickAct"
          onClick={() => navigate("/admin/gstinvoicemanagement")}
        >
          <h3>Generate Invoice</h3>
          <TbFileInvoice size={40} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
